<template>
  <div>
    <v-data-table
      :options.sync="options"
      :server-items-length="totalItems"
      :headers="headers"
      :items="forms"
      :search="search_form"
      :loading="loading"
      :footer-props="{
        'items-per-page-options': [10, 20, 30, 40, 50, 100],
      }"
      :items-per-page="50"
      :item-class="itemRowBackground"
      class="elevation-1"
      single-expand
      :expanded.sync="expanded"
      show-expand
    >
      <template v-slot:top>
        <v-layout class="pa-3">
          <v-text-field
            v-model="search_form"
            label="Vyhľadať"
          />
        </v-layout>
      </template>

      <template
        v-if="editable"
        v-slot:item.zaujem="{ item }"
      >
        <v-icon
          v-if="!item.zaujem"
          color="success"
          @click="showDialog(item)"
        >
          mdi-bookmark-plus
        </v-icon>
        <v-icon
          v-else
          color="error"
          @click="zrusitZaujem(item)"
        >
          mdi-bookmark-remove
        </v-icon>

        <!-- <v-btn
          v-if="user_type == 'admin'"
          color="primary"
          small
          class="ml-2"
          @click="iapsz(item)"
        >
          IAPSZ</v-btn> -->

        <router-link
          v-if="user_type == 'admin'"
          class="ml-2"
          :to="iapsz(item)"
        >
          IAPSZ
        </router-link>
      </template>

      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length">
          Pracovné zručnosti: {{ item.pracovne_zrucnosti }}
        </td>
      </template>

      <template v-slot:item.pracovne_zaradeny="{ item }">
        <span v-if="item.pracovne_zaradeny">Áno</span>
        <span v-else>Nie</span>
      </template>
    </v-data-table>

    <v-dialog
      v-model="dialog"
      width="500"
    >
      <v-card>
        <v-card-title>
          Ponuka práce
        </v-card-title>

        <v-card-text>
          <v-textarea
            v-model="newItemPonuka"
            label="Sem vpíšte konkrétnu ponuku pre klienta"
            auto-grow
            rows="3"
          />
        </v-card-text>

        <v-divider />

        <v-card-actions>
          <v-spacer />
          <v-btn
            color="primary"
            text
            @click="zaujem(selectedItem)"
          >
            Odoslať ponuku
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

import { APIService } from "@/http/APIService.js";
const apiService = new APIService();

export default {
  name: "SocialnyPodnikTable",
  props: {
    editable: { type: Boolean, default: false }
  },

  data() {
    return {
      timeout: null,

      dialog: false,
      newItemPonuka: "",
      selectedItem: null,

      loading: true,
      search_form: "",
      search: null,
      totalItems: 0,
      options: {},
      expanded: [],

      headers: [
        {
          text: "ID",
          value: "id_iapsz",
        },
        { text: "Vek", value: "age_1" },

        { text: "Okres", value: "trvale_bydlisko_okres" },

        {
          text: "Najvyššie dosiahnuté vzdelanie",
          value: "najvyssie_dosiahnute_vzdelanie",
        },
        { text: "Pôvodné povolanie", value: "povodne_povolanie" },
        { text: "Dátum možného nástupu", value: "nastup" },
        { text: "Typ dôchodcu", value: "typ_dochodcu" },
        { text: "Záujem", value: "zaujem", sortable: false },
        { text: "Stav", value: "status", sortable: false },
      ],

      forms: [],
    };
  },
  computed: {
    ...mapGetters("auth", ["user_type"])
  },

  watch: {
    search_form() {
      if (this.timeout) {
        clearTimeout(this.timeout);
      }
      this.timeout = setTimeout(() => {
        this.getDataFromApi();
      }, 500);
    },
    options: {
      handler() {
        this.getDataFromApi();
      },
    },
    deep: true,
  },

  methods: {
    iapsz(item) {
      return this.$router.resolve({
        name: "iapsz_udaje_o_klientovi",
        params: { id: item.id_iapsz },
      }).href;
    },

    itemRowBackground: function (item) {
      return item.zaujem == true ? "success lighten-5" : "";
    },

    showDialog(item) {
      this.newItemPonuka = "";
      this.selectedItem = item;
      this.dialog = true;
    },

    zaujem(item) {
      apiService.createIntegracnePodnikyZaujem(item, this.newItemPonuka).then(() => {
        this.getDataFromApi();
      }).finally(() => this.dialog = false);
    },

    zrusitZaujem(item) {
      apiService.deleteIntegracnePodnikyZaujem(item).then(() => {
        this.getDataFromApi();
      });
    },

    getForms(sort, search, limit, offset, filter_key, filter_value) {
      this.loading = true;

      apiService
        .getIntegracnePodnikyForms(
          sort,
          search,
          limit,
          offset,
          filter_key,
          filter_value
        )
        .then((response) => {
          this.forms = response.results;
          this.totalItems = response.count;
          this.loading = false;
        });
    },

    getDataFromApi() {
      this.loading = true;

      const { sortBy, sortDesc, page, itemsPerPage } = this.options;

      let sort = "";
      if (sortBy) {
        if (sortBy.length === 1 && sortDesc.length === 1) {
          sort = sortBy[0].replace(/\./g, "__").replace(/_full/g, "");
          if (!sortDesc[0]) sort = "-" + sort;
        }
      }

      let offset = "";
      if (itemsPerPage > 0) {
        offset = (page - 1) * itemsPerPage;
      }

      var filters = [];

      this.getForms(sort, this.search_form, itemsPerPage, offset, filters);
    },
  },

};
</script>
    
